import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, HardHat, FileCheck, MapPin, MessageSquare, Calculator } from 'lucide-react';
export function Credentials() {
  const credentials = [{
    icon: <FileCheck className="w-8 h-8 text-brand" data-id="element-50" />,
    title: 'PA License #934782',
    desc: 'Your project is 100% legal, protected & up to code'
  }, {
    icon: <HardHat className="w-8 h-8 text-gold" data-id="element-51" />,
    title: 'OSHA Certified #14-602163933',
    desc: 'Your home and family are always safe'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-brand" data-id="element-52" />,
    title: 'Full Insurance Coverage',
    desc: "Zero risk, zero worry — you're completely protected"
  }, {
    icon: <MapPin className="w-8 h-8 text-gold" data-id="element-53" />,
    title: 'Years of PA Experience',
    desc: 'We know local codes, local weather, local excellence'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-brand" data-id="element-54" />,
    title: 'A Team That Communicates',
    desc: "You're never left wondering — we keep you informed every step"
  }, {
    icon: <Calculator className="w-8 h-8 text-gold" data-id="element-55" />,
    title: 'FREE Estimates',
    desc: 'No surprises, no pressure — just honest conversations'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section className="py-16 bg-white relative z-10" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-59">
            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-60">
              <div className="h-px w-12 bg-gold" data-id="element-61"></div>
              <span className="text-gold font-bold uppercase tracking-widest text-xs" data-id="element-62">
                The Blue Sky Standard
              </span>
              <div className="h-px w-12 bg-gold" data-id="element-63"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy" data-id="element-64">
              Credentials You Can Trust
            </h2>
          </motion.div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-65">
          {credentials.map((cred, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 rounded-xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-100 relative overflow-hidden group hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all duration-500" data-id="element-66">
              <div className={`absolute top-0 left-0 w-full h-1 ${index % 2 === 0 ? 'bg-brand' : 'bg-gold'}`} data-id="element-67"></div>
              <div className="flex items-center gap-4" data-id="element-68">
                <div className="bg-cream w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-500" data-id="element-69">
                  {cred.icon}
                </div>
                <div data-id="element-70">
                  <h3 className="text-base font-heading font-bold text-navy mb-1" data-id="element-71">
                    {cred.title}
                  </h3>
                  <p className="text-muted text-sm leading-snug" data-id="element-72">{cred.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}